<template>
  <!-- 底部悬浮按钮 -->
  <div class="bottom-box">
    <div class="action-button" @click="handleClick">{{ content }}</div>
  </div>
</template>

<script>
export default {
  name: 'app-bottom-button',
  data() {
    return {};
  },
  props: {
    content: {
      type: String,
      default() {
        return '';
      },
    },
  },
  methods: {
    handleClick() {
      this.$emit('onClick');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/common';
@import '@/assets/style/1px';
.bottom-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 9px 12px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 9px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 9px);
  background-color: #fff;
  box-sizing: border-box;
  z-index: 19;
  &:after {
    @include setTopLine(#ececec);
  }
  .action-button {
    height: 42px;
    background: rgba(255, 225, 0, 1);
    border-radius: 4px;
    text-align: center;
    line-height: 42px;
    font-size: 16px;
    font-family: PingFangSC-Regular;
  }
}
</style>

